/**
 * Locale ↔ document direction.
 *
 * WHY: the RTL-ready claim needs `<html dir>` to actually follow the locale.
 * Layout already uses CSS logical properties; this flips the base direction so
 * those properties resolve correctly. UTC is stored; the formatter localizes.
 */

/** BCP-47 language subtags that are written right-to-left. */
const RTL_LANGS = new Set(['ar', 'he', 'fa', 'ur', 'ps', 'sd', 'yi', 'dv']);

/** Resolve writing direction for a locale. */
export function directionFor(locale: string): 'ltr' | 'rtl' {
  const lang = locale.split('-')[0]?.toLowerCase() ?? '';
  return RTL_LANGS.has(lang) ? 'rtl' : 'ltr';
}

/** Apply `lang` + `dir` to the document root from the active locale. */
export function applyDocumentLocale(doc: Document, locale: string): void {
  doc.documentElement.lang = locale;
  doc.documentElement.dir = directionFor(locale);
}
